import ViewBudgetPeriodActions from 'src/sections/view_budget_period/ViewBudgetPeriodActions';
import ViewBudgetPeriodContextProvider from 'src/sections/view_budget_period/ViewBudgetPeriodContext';
import ViewBudgetPeriodTable from 'src/sections/view_budget_period/ViewBudgetPeriodTable';

const ViewBudgetPeriod = () => (
  <ViewBudgetPeriodContextProvider>
    <ViewBudgetPeriodActions />
    <ViewBudgetPeriodTable />
  </ViewBudgetPeriodContextProvider>
);

export default ViewBudgetPeriod;
